import { css } from '@emotion/react'
import { Card, colors, CompanyLogo, Divider, font } from 'plume-ui'
import * as React from 'react'
import { formatDate } from '@/lib/date'
import { InvestorFinanceNews } from '../../../types'
import { CardInnerTitle } from '../../atoms/CardInnerTitle'
import { EmptyCard } from '../../common/EmptyCard'
import { getCategoryTagColor } from '@/lib/colors'

type Props = {
  list: InvestorFinanceNews[]
}

export const InvestorFinanceNewsList: React.FC<Props> = (props) => {
  return (
    <Card>
      <CardInnerTitle title="資金調達ニュース" />
      {props.list.length > 0 ? (
        props.list.map((n, i) => {
          const org = n.company ? n.company : n.investor
          if (!org) {
            return
          }
          const categoryColor = getCategoryTagColor(n.category)
          return (
            <React.Fragment key={i}>
              <Card.Content>
                <div
                  css={css`
                    display: flex;
                  `}
                >
                  <a href={org.path}>
                    <CompanyLogo name={org.name} src={org.imageUrl} />
                  </a>
                  <div
                    css={css`
                      flex: 1;
                      margin-left: 1rem;
                    `}
                  >
                    <a href={n.urls[0]} target="_blank">
                      <div
                        css={css`
                          font-size: 14px;
                          color: ${colors.text};
                          line-height: 1.5;
                          font-weight: ${font.weight.bold};
                        `}
                      >
                        {n.title}
                      </div>
                    </a>
                    <div
                      css={css`
                        display: flex;
                        align-items: center;
                        margin: 4px 0;
                      `}
                    >
                      <div
                        css={css`
                          font-size: 12px;
                          line-height: 1.25;
                          color: ${categoryColor.color};
                          background-color: ${categoryColor.backgroundColor};
                          border-radius: 15px;
                          padding: 3px 8px;
                          margin: 0 8px 0 0;
                        `}
                      >
                        {n.category}
                      </div>
                      <div
                        css={css`
                          font-size: 12px;
                          line-height: 1.25;
                          color: ${colors.textLight};
                          padding: 4px 0;
                        `}
                      >
                        {formatDate(n.publishedAt, 'yyyy/MM/dd')}
                      </div>
                    </div>

                    <a href={org.path}>
                      <div
                        css={css`
                          font-size: 14px;
                          line-height: 1.25;
                          font-size: 14px;
                          color: ${colors.textStrong};
                        `}
                      >
                        {org.name}
                      </div>
                    </a>
                  </div>
                </div>
              </Card.Content>
              <Divider />
            </React.Fragment>
          )
        })
      ) : (
        <EmptyCard />
      )}
    </Card>
  )
}
